import { render, staticRenderFns } from "./OcrModal.vue?vue&type=template&id=79a2e497&scoped=true"
import script from "./OcrModal.vue?vue&type=script&lang=js"
export * from "./OcrModal.vue?vue&type=script&lang=js"
import style0 from "./OcrModal.vue?vue&type=style&index=0&id=79a2e497&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a2e497",
  null
  
)

export default component.exports